import { ErrorBanner } from 'ui/components/compounds/ErrorBanner/ErrorBanner';
import { Container } from 'ui/components';

const ProductsShowcasesEmpty = () => (
  <Container fluid marginTop="sp-8">
    <ErrorBanner
      title="Infelizmente tivemos um problema para carregar esta área de produtos"
      subtitle="Recomendamos que você aguarde alguns minutos. Enquanto isso, veja ou busque por outros produtos."
    />
  </Container>
);

export default ProductsShowcasesEmpty;
